<div class="layout-wrapper landing section intro-section pb-0">
  <div class="teacher-page-container" [dir]="translate.currentLang === 'ar' ? 'rtl' : 'ltr'">
    <!-- Hero Section -->
    <section class="hero-section py-5">
    <!-- Contact Form Section -->
    <app-contact></app-contact>
       </section> 
  </div>
</div>
